import { RootState } from '../../../app/store';

export const selectIsExportModalOpen = (state: RootState) => {
  return state.devicesTable.isExportModalOpen;
};
